module.exports = __webpack_public_path__ + "static/img/car_3.969681d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/image/car_3.png
// module id = DhIS
// module chunks = 1